<template>
  <div class="analysis-chart-wrap" v-loading="loading">
    <!-- 实时数据 -->
    <!-- <div class="data-list" id="codeDataList" v-if="codes && showThisData">
      <div class="data-item" v-for="(item, index) in codes" :key="index" :style="{background:getColor(index)}">
        <div class="value" :style="{ marginTop: item.value ? '-34px' : '0px' }">
          <countTo
            v-if="item.value"
            :startVal="0"
            :endVal="item.value"
            :decimals="2"
            :duration="100"
          ></countTo>
          <label v-else>-</label>
        </div>
        <div class="title">{{ item.title }}</div>
      </div>
    </div> -->
    <div
      style="position: relative; width: 100%; height: 400px"
      v-show="!isState"
      class="box"
    >
      <div :id="id" style="width: 100%; height: 100%" v-resize="resize"></div>
      <div
        style="position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;background: #fff;"
        v-show="showTable"
      >
        <div class="tab-small">
          <el-radio-group size="small" v-model="tabSelectedIndex">
            <el-radio-button
              :label="index"
              v-for="(item, index) in tablesData"
              :key="index"
              >{{ item.label }}</el-radio-button
            >
          </el-radio-group>
          <el-button type="text" @click="downTable()">下载</el-button>
          <i class="el-icon-circle-close" @click="showTable = false"></i>
        </div>
        <div class="table-div">
          <nk-table
            id="downTableId"
            v-if="tablesData.length > 0"
            :data="tablesData[tabSelectedIndex].data"
            :columns="tablesData[tabSelectedIndex].columns"
            :border="false"
          ></nk-table>
        </div>
      </div>
    </div>

    <div
      class="item-box title-box box"
      v-if="analysisChartObj && analysisChartObj.tabType == 'imbalance'"
    >
      正常电压不平衡度允许值为２％，短时不得超过４％；最大电流不平衡度相差不超过10%
    </div>
    <div style="height: 645px" v-show="isState">
      <nk-table
        :data="stateDataToPage"
        :columns="stateColums"
        :border="false"
        :showPage="true"
        :page="statePage"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></nk-table>
    </div>
    <div class="item-box table-box box" v-show="eventTableData.length > 0">
      <nk-table
        :data="eventTableData"
        :columns="resultColums"
        :border="false"
      ></nk-table>
    </div>
    <div class="item-box table-box box" v-if="showMaxMinTable && !isState">
      <nk-table
        :data="maxMinTable"
        :columns="columns"
        :border="false"
      ></nk-table>
    </div>
    <el-dialog
      title="选择对标线"
      :visible.sync="visibleBenchmarking"
      width="500px"
    >
      <div v-loading="benchmarkingLoading">
        <el-checkbox-group
          style="width: 100%; display: flex; flex-wrap: wrap"
          v-model="checkList"
        >
          <div
            class="checkbox"
            v-for="(item, index) in eventDetectRegulations"
            :key="index"
          >
            <el-checkbox :label="index">{{ item.label }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleBenchmarking = false">取 消</el-button>
        <el-button type="primary" @click="addBleBenchmarking">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="选择显示数据项"
      :visible.sync="visibleOther"
      width="500px"
    >
      <div>
        <el-checkbox-group
          style="width: 100%; display: flex; flex-wrap: wrap"
          v-model="checkCodeList"
        >
          <div class="checkbox" v-for="(item, index) in codes" :key="index">
            <el-checkbox :label="index">{{ item.title }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleOther = false">取 消</el-button>
        <el-button type="primary" @click="addCode">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import echarts from "echarts";
import uuidv1 from "uuid/v1";
import api from "../../../../../common/api/index";
import { TAB_MAP, TAB_UNIT_MAP } from "@/config/index.js";
import NkTable from "@/components/common/NkTable.vue";
import handleData from "@/utils/handleData.js";
import DateTool from "@/utils/dateTool.js";
import dateTool from "@/utils/dateTool.js";
import { EVEN } from "@/config/data.js";
import { calcEventTime } from "./calc.js";
import socket from "@/utils/websocket.js"; // 组件
import dayjs from 'dayjs'
import { exportExcel } from '@/utils'

export default {
  props: {
    forwardFlowUnit: {
      type: String,
      default: "",
    },
    /**
     * 是否显示最大最小值表格
     */
    showMaxMinTable: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示对标线
     */
    showBenchmarking: {
      type: Boolean,
      default: true,
    },
  },
  components: { NkTable, countTo },
  data() {
    return {
      analysisChartObj: null,
      showTable: false,
      chartId: null,
      charts: null,
      loading: false,
      tablesData: [],
      tabSelectedIndex: 0,
      columns: [],
      maxMinTable: [],
      resultColums: [
        { prop: "label", label: "越限类型", show: true },
        { prop: "normalTime", label: "正常持续时间", show: true },
        { prop: "normalScale", label: "正常占比百分比", show: true },
        { prop: "eventTime", label: "异常持续时间", show: true },
        { prop: "eventScale", label: "异常占比百分比", show: true },
      ],
      eventTableData: [],
      visibleBenchmarking: false,
      checkList: [],
      benchmarkingLoading: true,
      eventDetectRegulations: [],
      codes: null,
      visibleOther: false,
      checkCodeList: [],
      isState: false,
      stateColums: [],
      stateData: [],
      statePage: {
        pageSizes: [100, 200, 500, 1000],
        size: 100,
        total: 0,
        pageIndex: 0,
      },
      stateDataToPage: [],
      measuringData: [],
      hideCodeData: [],
      socket: null,
      showThisData: false,
    };
  },
  created() {},
  computed: {
    id() {
      return this.getId();
    },
    getColor() {
      return function(index) {
        let colors = [
          "#d68818",
          "#88a80a",
          "#308145",
          "#318e96",
          "#326293",
          "#3d66c1",
          "#3a32ab",
          "#6325aa",
          "#9a1eac",
          "#b92626",
        ];
        return colors[index % colors.length];
      };
    },
  },
  mounted() {
    let vm = this;
    vm.$nextTick(function() {
      //vm.drawLine(this.chartId)
    });
    /*监听窗口变化，重置echarts表格*/
    // window.onresize = function () {
    //   vm.charts.resize();
    // };
  },
  beforeDestroy() {
    this.charts.clear();
  },
  methods: {
    resize() {
      let vm = this;
      if (vm.charts) {
        vm.charts.resize();
      }
    },
    getId() {
      this.chartId = uuidv1();
      return this.chartId;
    },
    async getData(chartObj, checkCodeList = []) {
      const analysisChartObj = {...chartObj}
      // if (analysisChartObj.timeType === 'timeInterval') {
      //   analysisChartObj.timeType = 'day'
      // }
      console.error(analysisChartObj)
      let vm = this;
      if (vm.loading) {
        return;
      }
      vm.checkList = [];
      vm.showTable = false;
      vm.measuringData = [];
      vm.analysisChartObj = analysisChartObj;
      let tabType = analysisChartObj.tabType;
      if (vm.charts) {
        vm.charts.dispose();
      }
      vm.drawLine(vm.chartId);
      if (
        !analysisChartObj.measureId ||
        analysisChartObj.measureId.length == 0 ||
        analysisChartObj.measureName.length == 0 ||
        analysisChartObj.startTime.length == 0 ||
        analysisChartObj.endTime.length == 0
      ) {
        return;
      }
      vm.loading = true;

      let codes = [];
      api.measure
        .getMeasureProperty(analysisChartObj.measureId, "__ACWiringSystems")
        .then((res) => {
          if (res.data.length > 0) {
            codes = handleData.setCodes(
              tabType,
              /3Phase3Wire/g.test(res.data[0].value) ? "三相三线" : ""
            );
          } else {
            codes = handleData.setCodes(tabType, "");
          }
          /**
           * 判断本地config是否有默认隐藏数据项
           */
          let isStart = false;
          if (vm.hideCodeData.length == 0) {
            isStart = true;
          } else {
            isStart = true;
            if (vm.hideCodeData.length == 1) {
              if (Object.keys(vm.hideCodeData[0]) == 0) {
                isStart = false;
              }
            } else {
              for (let i = 0; i < codes.length; i++) {
                const element = codes[i];
                const hideItem = vm.hideCodeData.find(
                  (c) => c.code == element.code && c.num == element.num
                );
                if (hideItem) {
                  isStart = false;
                }
              }
            }
          }

          if (isStart === true) {
            for (let i = 0; i < codes.length; i++) {
              const element = codes[i];
              if (element.show == false) {
                vm.hideCodeData.push(element);
              }
            }
          }
          //
          api.measure
            .getUniqueMeasuresExpressions(
              JSON.stringify([analysisChartObj.measureId])
            )
            .then(async (res) => {
              if (res.data.length > 0) {
                let expressions = [];
                for (let i = 0; i < res.data[0].expressionGroups.length; i++) {
                  for (
                    let j = 0;
                    j < res.data[0].expressionGroups[i].expression.length;
                    j++
                  ) {
                    expressions.push(
                      res.data[0].expressionGroups[i].expression[j]
                    );
                  }
                }
                let expressionCodes = [];
                for (let i = 0; i < codes.length; i++) {
                  const element = codes[i];
                  let expressionArr = [];
                  if (analysisChartObj.tabType == "smokeSensation") {
                    expressionArr = expressions.filter(
                      (c) =>
                        c.pointCode == codes[i].code &&
                        c.name.indexOf("smokeSensation") > -1
                    );
                  } else {
                    expressionArr = expressions.filter(
                      (c) => c.pointCode == codes[i].code
                    );
                  }
                  for (let j = 0; j < expressionArr.length; j++) {
                    const expressionCodeItemIndex = expressionCodes.findIndex(
                      (c) =>
                        c.code == expressionArr[j].pointCode &&
                        c.num == expressionArr[j].pointNumber
                    );
                    if (expressionCodeItemIndex == -1) {
                      expressionCodes.push({
                        code: codes[i].code,
                        num: expressionArr[j].pointNumber,
                        title: expressionArr[j].displayName,
                        show: element.show,
                      });
                    }
                  }
                }
                if (expressionCodes.length > 0) {
                  codes = expressionCodes;
                }
                //设置显示隐藏数据项
                for (let i = 0; i < codes.length; i++) {
                  let bol = false;
                  const hideCodeIndex = vm.hideCodeData.findIndex(
                    (c) => c.code == codes[i].code && c.num == codes[i].num
                  );
                  if (hideCodeIndex == -1) {
                    bol = true;
                  }
                  codes[i].show = bol;
                }
                vm.checkCodeList = checkCodeList;
                vm.codes = codes;
                //优先获取对标线
                if (vm.showBenchmarking) {
                  vm.eventDetectRegulations = [];
                  vm.checkList = [];
                  vm.eventTableData = [];
                  await vm.getEventDetectRegulations(
                    vm.analysisChartObj.measureId
                  );
                }
                //如果是用电量  特殊处理
                const typeArr = ["water", "ele"];
                if (typeArr.findIndex((c) => c === tabType) > -1) {
                  vm.showThisData = false;
                  vm.getQuantity(analysisChartObj, codes, tabType);
                } else {
                  const apiType = handleData.getTabTypeForApi(tabType);
                  //生成measures
                  vm.setMaxMinTable(tabType);
                  let measures = [];
                  for (let i = 0; i < codes.length; i++) {
                    if (codes[i].show) {
                      measures.push({
                        measureId: analysisChartObj.measureId,
                        pointNumber:
                          typeof codes[i].num == "number" ? codes[i].num : 0,
                        pointCode: codes[i].code,
                      });
                    }
                  }
                  //按采集间隔
                  if (
                    apiType == "measuring" &&
                    analysisChartObj.searchType == "measuring"
                  ) {
                    vm.loadAllMeasuringData(
                      measures,
                      analysisChartObj.startTime,
                      analysisChartObj.endTime,
                      tabType,
                      codes,
                      analysisChartObj.measureName
                    );
                  }
                  //采集类
                  else if (apiType == "measuring") {
                    api.measuring
                      .getMeasuringValueHour2(
                        measures,
                        analysisChartObj.startTime,
                        analysisChartObj.endTime,
                        0
                      )
                      .then((res) => {
                        if (res) {
                          if (tabType == "smokeSensation") {
                            vm.isState = true;
                            vm.setState(
                              res.data,
                              codes,
                              tabType,
                              analysisChartObj.measureName,
                              analysisChartObj,
                              analysisChartObj.timeType
                            );
                          } else {
                            vm.isState = false;
                            //生成series
                            vm.setMeasuringSeries(
                              res.data,
                              codes,
                              tabType,
                              analysisChartObj.measureName,
                              analysisChartObj,
                              analysisChartObj.timeType
                            );
                          }
                        }
                      });
                  }
                  //统计类
                  else {
                    const isMonth = analysisChartObj.timeType === 'month';
                    const fnStr = isMonth ? 'getQuantityDay3' : 'getQuantityHour2'
                    api.quantity[fnStr](
                        measures,
                        analysisChartObj.startTime,
                        analysisChartObj.endTime,
                        0
                      )
                      .then((res) => {
                        if (isMonth) res.data[0].data = res.data[0].data[0];
                        //生成series
                        vm.setQuantitySeries(
                          res.data,
                          codes,
                          tabType,
                          analysisChartObj.measureName,
                          analysisChartObj,
                          analysisChartObj.timeType
                        );
                      });
                  }
                }
              }
            });
        });
    },
    getQuantity(analysisChartObj, codes, tabType) {
      let vm = this;
      let api1 = null;
      let api2 = null;
      let isDay = false;
      const isTimeInterval = analysisChartObj.timeType === "timeInterval"
      //获取同期
      const qoqDateObj = isTimeInterval ? analysisChartObj : DateTool.getLinkRatioDate(
        analysisChartObj.timeType,
        analysisChartObj.startTime,
        analysisChartObj.endTime
      );
      if (!isTimeInterval) {
        qoqDateObj.endTime = dayjs(qoqDateObj.endTime).subtract(1, 'second').format('YYYY/MM/DD HH:mm:ss');
      }
      if (analysisChartObj.timeType == "day" || isTimeInterval) {
        api1 = api.quantity.getQuantityHour(
          analysisChartObj.measureId,
          analysisChartObj.startTime,
          analysisChartObj.endTime,
          codes[0].code,
          typeof codes[0].num == "number" ? codes[0].num : 0,
          0
        );
        /**
         * 错误的地方
         */
        if (!isTimeInterval) {
          api2 = api.quantity.getQuantityHour(
            analysisChartObj.measureId,
            qoqDateObj.startTime,
            qoqDateObj.endTime,
            codes[0].code,
            typeof codes[0].num == "number" ? codes[0].num : 0,
            0
          );
        }
      } else if (
        analysisChartObj.timeType == "week" ||
        analysisChartObj.timeType == "month"
      ) {
        isDay = true;
        api1 = api.quantity.getQuantityDay(
          analysisChartObj.measureId,
          analysisChartObj.startTime,
          analysisChartObj.endTime,
          null,
          codes[0].code,
          typeof codes[0].num == "number" ? codes[0].num : 0,
          0
        );
        api2 = api.quantity.getQuantityDay(
          analysisChartObj.measureId,
          qoqDateObj.startTime,
          qoqDateObj.endTime,
          null,
          codes[0].code,
          typeof codes[0].num == "number" ? codes[0].num : 0,
          0
        );
      } else if (analysisChartObj.timeType == "year") {
        api1 = api.quantity.getQuantityMonth(
          analysisChartObj.measureId,
          analysisChartObj.startTime,
          analysisChartObj.endTime,
          codes[0].code,
          typeof codes[0].num == "number" ? codes[0].num : 0,
          0
        );
        api2 = api.quantity.getQuantityMonth(
          analysisChartObj.measureId,
          qoqDateObj.startTime,
          qoqDateObj.endTime,
          codes[0].code,
          typeof codes[0].num == "number" ? codes[0].num : 0,
          0
        );
      } else {
        return;
      }
      Promise.all([api1, api2].filter(Boolean)).then((arrRes) => {
        vm.setQoqSeries(
          arrRes,
          codes,
          tabType,
          analysisChartObj.measureName,
          [analysisChartObj, qoqDateObj],
          analysisChartObj.timeType,
          isDay
        );
      });
    },
    drawLine(id) {
      let vm = this;
      this.charts = echarts.init(document.getElementById(id));
      let option = {
        legend: {
          textStyle: {
            color: "#bcbdbe",
          },
        },
        xAxis: {
          type: "time",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe",
            },
          },
        },
        grid: {
          x: 80,
          y: 45,
          x2: 80,
          y2: 80,
          containLabel: true,
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "90%",
            left: "center",
          },
        ],
        yAxis: {
          type: "value",
          name: "A",
          nameTextStyle: {
            //y轴上方单位的颜色
            color: "#878b97",
          },
          min: function(value) {
            if (value.min > 0) {
              return Math.floor(Number(value.min) - Number(value.min) * 0.2);
            } else {
              return Math.floor(Number(value.min) + Number(value.min) * 0.2);
            }
          },
          max: function(value) {
            if (value.max > 0) {
              return Math.ceil(Number(value.max) + Number(value.max) * 0.2);
            } else {
              return Math.ceil(Number(value.max) - Number(value.max) * 0.2);
            }
          },
          scale: true /*按比例显示*/,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2,
            },
          },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#bcbdbe"],
              width: 1,
              type: "solid",
            },
          },
        },
        label: {},
        tooltip: {
          trigger: "axis",
          color: "#bcbdbe",
        },
        toolbox: {
          feature: {
            myTool: {
              show: vm.showBenchmarking,
              title: "对标线",
              icon: "image:///img/icon/icon-echart.png",
              z: "999",
              left: "center",
              onclick: function() {
                if (vm.analysisChartObj) {
                  vm.visibleBenchmarking = true;
                }
              },
            },
            myTool2: {
              title: "选择更多数据项",
              icon: "image:///img/icon/icon-other.png",
              z: "999",
              left: "center",
              onclick: function() {
                // if (vm.analysisChartObj) {
                //   vm.visibleBenchmarking = true;
                // }
                let checkCodeList = [];
                for (let index = 0; index < vm.codes.length; index++) {
                  if (vm.codes[index].show) {
                    checkCodeList.push(index);
                  }
                }
                vm.checkCodeList = checkCodeList;
                vm.visibleOther = true;
              },
            },
            saveAsImage: {},
            dataView: {
              show: true,
              readOnly: true,
              optionToContent: function(opt) {
                vm.setTableData(opt);
                vm.showTable = !vm.showTable;
                return null;
              },
            },
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
          right: "40",
        },
        // color: [
        //   '#d68818',
        //   '#88a80a',
        //   '#308145',
        //   '#318e96',
        //   '#326293',
        //   '#3d66c1',
        //   '#3a32ab',
        //   '#6325aa',
        //   '#9a1eac',
        //   '#b92626',
        // ],
        color: [
          "#00AAFF",
          "#52CCA3",
          "#CCCC00",

          "#318e96",
          "#326293",
          "#3d66c1",
          "#3a32ab",
          "#6325aa",
          "#9a1eac",
          "#b92626",
        ],
        series: [],
      };
      this.charts.setOption(option);
    },
    addCode() {
      let vm = this;
      if (vm.checkCodeList.length > 0) {
        vm.visibleOther = false;
        for (let i = 0; i < vm.codes.length; i++) {
          const index = vm.checkCodeList.findIndex((c) => c == i);
          if (index == -1) {
            vm.hideCodeData.push(vm.codes[i]);
          } else {
            const hideIndex = vm.hideCodeData.findIndex(
              (c) => c.code == vm.codes[i].code && c.num == vm.codes[i].num
            );
            if (hideIndex > -1) {
              vm.hideCodeData.splice(hideIndex, 1);
            }
          }
        }
        if (vm.hideCodeData.length == 0) {
          vm.hideCodeData.push({});
        }
        vm.getData(vm.analysisChartObj, vm.checkCodeList);
      } else {
        this.$message({
          message: "请选择其中的数据项！",
          type: "warning",
        });
      }
    },
    setTableData(opt) {
      let vm = this;
      let series = opt.series;
      let tablesData = [];
      for (let i = 0; i < series.length; i++) {
        let columns = [
          { prop: "time", label: "时间", sortable: true, show: true },
          { prop: "val", label: series[i].name, show: true },
        ];

        let data = [];
        for (let j = 0; j < series[i].data.length; j++) {
          const obj = series[i].data[j];
          if (opt.xAxis[0].type === "time") {
            data.push({ time: obj[0], val: obj[1] });
          } else {
            data.push({ time: opt.xAxis[0].data[j], val: obj });
          }
        }

        tablesData.push({
          columns: columns,
          data: data,
          align: "right",
          label: series[i].name,
        });
      }
      vm.tablesData = tablesData;
    },
    setMaxMinTable(val) {
      let vm = this;
      if (vm.showMaxMinTable == false) {
        return;
      }
      const label = TAB_MAP[val].split("(")[0];
      vm.columns = [
        { prop: "measureName", label: "测量点名称", show: true },
        { prop: "codeLabel", width: 180, label: "采集类型", show: true },
        {
          prop: "max",
          label: "最大" + TAB_MAP[val],
          align: "right",
          show: true,
        },
        {
          prop: "maxTime",
          label: "最大" + label + "发生时间",
          show: true,
        },
        {
          prop: "min",
          label: "最小" + TAB_MAP[val],
          align: "right",
          show: true,
        },
        {
          prop: "minTime",
          label: "最小" + label + "发生时间",
          show: true,
        },
      ];
    },
    loadAllMeasuringData(
      measures,
      startTime,
      endTime,
      tabType,
      codes,
      measureName
    ) {
      let vm = this;
      if (new Date(endTime).getTime() > new Date().getTime()) {
        endTime = dateTool.format(new Date(), "yyyy-MM-dd hh:mm:ss");
      }
      api.measuring
        .getMeasuringValueAll2(measures, startTime, endTime, 0, 5000)
        .then((res) => {
          //判断是否有已经缓存的数据，合并缓存数据
          let measuringData = JSON.parse(JSON.stringify(vm.measuringData));
          if (measuringData !== null && measuringData.length > 0) {
            for (let k = 0; k < measuringData.length; k++) {
              let lineData = measuringData[k].data.data.concat(
                res.data[k].data.data
              );
              measuringData[k].data.data = lineData;
            }
          } else {
            measuringData = res.data;
          }
          vm.measuringData = measuringData;

          if (
            new Date(res.data[0].data.endTime).getTime() -
              new Date(endTime).getTime() !==
            0
          ) {
            //一直load数据
            vm.loadAllMeasuringData(
              measures,
              res.data[0].data.endTime,
              endTime,
              tabType,
              codes,
              measureName
            );
          } else {
            if (tabType == "smokeSensation") {
              vm.isState = true;
              vm.setStateAll(
                vm.measuringData.length == 0
                  ? res.data
                  : JSON.parse(JSON.stringify(vm.measuringData)),
                codes,
                tabType,
                measureName
              );
            } else {
              vm.isState = false;

              vm.setMeasuringAllSeries(
                vm.measuringData.length == 0
                  ? res.data
                  : JSON.parse(JSON.stringify(vm.measuringData)),
                codes,
                tabType,
                measureName
              );
            }
          }
        });
    },

    /**
     * 生成采集的图表数据 按小时
     */
    setMeasuringSeries(data, codes, tabType, measureName, dateObj, timeType) {
      let vm = this;
      let series = [];
      let maxMinTable = [];
      let timeObj = DateTool.createXAxisObj(
        timeType,
        dateObj.startTime,
        dateObj.endTime
      );
      let xAxisData = [];
      for (let key in timeObj.timeObj) {
        xAxisData.push(key);
      }
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const codeLabel = codes.find(
          (obj) =>
            obj.code == element.pointCode && element.pointNumber == obj.num
        ).title;
        let seriesItemData = [];
        let xObj = JSON.parse(JSON.stringify(timeObj.timeObj));
        for (let j = 0; j < element.data.data.length; j++) {
          xObj[
            DateTool.format(new Date(element.data.data[j].time), timeObj.format)
          ] =
            element.data.data[j].value !== null
              ? element.data.data[j].value.toFixed(2)
              : "-";
        }
        for (let index in xObj) {
          seriesItemData.push(xObj[index]);
        }
        series.push({
          data: seriesItemData,
          name: codeLabel,
          type: "line",
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" },
            ],
          },
          lineStyle: {
            width: 3,
          },
          markLine: {
            data: [],
          },
        });
        //找最大最小值
        if (vm.showMaxMinTable == true) {
          if (element.data.data.length > 0) {
            element.data.data.sort(function(a, b) {
              return a.value - b.value;
            });
            maxMinTable.push({
              measureName: measureName,
              codeLabel: codeLabel,
              max:
                element.data.data[element.data.data.length - 1].value !== null
                  ? element.data.data[
                      element.data.data.length - 1
                    ].value.toFixed(2)
                  : "-",
              maxTime: element.data.data[element.data.data.length - 1].time,
              min:
                element.data.data[0].value !== null
                  ? element.data.data[0].value.toFixed(2)
                  : "-",
              minTime: element.data.data[0].time,
            });
          } else {
            maxMinTable.push({
              measureName: measureName,
              codeLabel: codeLabel,
              max: "-",
              maxTime: "-",
              min: "-",
              minTime: "-",
            });
          }
        }
      }
      vm.maxMinTable = maxMinTable;
      vm.charts.setOption({
        tooltip: {
          trigger: "axis",
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe",
            },
          },
          data: xAxisData,
        },
        // 功率不要单位
        yAxis: { name: tabType !== 'power' ? TAB_UNIT_MAP[tabType] : '' },
      });
      let option = vm.charts.getOption();
      option.series = series;
      vm.charts.setOption(option, true);
      vm.addBleBenchmarking();
      vm.loading = false;
    },
    /**
     * 生成采集的图表数据，按采集间隔
     */
    setMeasuringAllSeries(data, codes, tabType, measureName) {
      let vm = this;
      let series = [];
      let maxMinTable = [];
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const codeLabel = codes.find(
          (obj) =>
            obj.code == element.pointCode && element.pointNumber == obj.num
        ).title;
        let seriesItemData = [];

        for (let j = 0; j < element.data.data.length; j++) {
          if (element.data.data[j].value == null) {
            seriesItemData.push([element.data.data[j].time, "-"]);
          } else {
            seriesItemData.push([
              element.data.data[j].time,
              element.data.data[j].value.toFixed(2),
            ]);
          }
        }
        series.push({
          data: seriesItemData,
          name: codeLabel,
          type: "line",
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" },
            ],
          },
          smooth: true,
          symbol: "none",
          sampling: "max",
          animation: false,
          lineStyle: {
            width: 3,
          },
          markLine: {
            data: [],
          },
        });
        //找最大最小值
        if (vm.showMaxMinTable == true) {
          if (element.data.data.length > 0) {
            element.data.data.sort(function(a, b) {
              return a.value - b.value;
            });
            maxMinTable.push({
              measureName: measureName,
              codeLabel: codeLabel,
              max:
                element.data.data[element.data.data.length - 1].value !== null
                  ? element.data.data[
                      element.data.data.length - 1
                    ].value.toFixed(2)
                  : "-",
              maxTime: element.data.data[element.data.data.length - 1].time,
              min:
                element.data.data[0].value !== null
                  ? element.data.data[0].value.toFixed(2)
                  : "-",
              minTime: element.data.data[0].time,
            });
          } else {
            maxMinTable.push({
              measureName: measureName,
              codeLabel: codeLabel,
              max: "-",
              maxTime: "-",
              min: "-",
              minTime: "-",
            });
          }
        }
      }
      vm.maxMinTable = maxMinTable;
      let option = vm.charts.getOption();
      option.dataZoom = [
        {
          type: "inside",
          show: true,
          realtime: true,
        },
        {
          show: true,
          realtime: true,
          end: 100,
          type: "slider",
          width: "90%",
          left: "center",
        },
      ];
      option.tooltip = {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter(params) {
          let str = "";
          for (let i = 0; i < params.length; i++) {
            if (i === 0) {
              str += `${params[i].data[0]}<br />`;
            }
            str += `${params[i].seriesName}:${params[i].data[1]}<br />`;
          }
          return str;
          ///
        },
      };
      option.xAxis = {
        type: "time",
        boundaryGap: false,
        axisLine: {
          lineStyle: {
            color: "#bcbdbe",
            width: 2,
          },
        },
        splitLine: { show: false },
        axisLabel: {
          textStyle: {
            color: "#bcbdbe",
          },
        },
      };
      option.yAxis = {
        name: tabType !== 'power' ? TAB_UNIT_MAP[tabType] : '',
        min: function(value) {
          if (value.min > 0) {
            return Math.floor(Number(value.min) - Number(value.min) * 0.2);
          } else {
            return Math.floor(Number(value.min) + Number(value.min) * 0.2);
          }
        },
        max: function(value) {
          if (value.max > 0) {
            return Math.ceil(Number(value.max) + Number(value.max) * 0.2);
          } else {
            return Math.ceil(Number(value.max) - Number(value.max) * 0.2);
          }
        },
      };
      option.series = series;
      vm.charts.setOption(option, true);
      // vm.addBleBenchmarking();
      vm.loading = false;
    },
    // 获取小时秒分的时候是不会补充0的，需要自己转换一下
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    /**
     * 生成统计的图表数据
     */
    setQuantitySeries(data, codes, tabType, measureName, dateObj, timeType) {
      let vm = this;
      let series = [];
      let maxMinTable = [];
      let timeObj = DateTool.createXAxisObj(
        timeType,
        dateObj.startTime,
        dateObj.endTime
      );
      let xAxisData = [];
      for (let key in timeObj.timeObj) {
        xAxisData.push(key);
      }

      // 月
      if (timeType === 'month') {
        const startDate = new Date(dateObj.startTime)
        const days = new Date(startDate.getFullYear(), startDate.getDay(), 0).getDate();
        xAxisData = new Array(days).fill(1).map((k, i) => `${i < 9 ? 0 : ''}${i + 1}日`)
      }

      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const codeLabelOne = codes.find(
          (obj) =>
            obj.code == element.pointCode && element.pointNumber == obj.num
        );
        let codeLabel = null;
        if (codeLabelOne) {
          codeLabel = codeLabelOne.title;
        }
        let seriesItemData = [];
        let xObj = JSON.parse(JSON.stringify(timeObj.timeObj));
        for (let j = 0; j < element.data.length; j++) {
          xObj[
            DateTool.format(new Date(element.data[j].time), timeObj.format)
          ] = element.data[j].value.toFixed(2);
        }
        for (let index in xObj) {
          seriesItemData.push(xObj[index]);
        }
        // 月
        if (timeType === 'month') {
          seriesItemData = seriesItemData.filter(k => k !== '-');
        }
        series.push({
          data: seriesItemData,
          name: codeLabel,
          type: "line",
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" },
            ],
          },
          lineStyle: {
            width: 3,
          },
          markLine: {
            data: [],
          },
        });
        //找最大最小值
        if (vm.showMaxMinTable == true) {
          if (element.data.length > 0) {
            element.data.sort(function(a, b) {
              return a.value - b.value;
            });
            maxMinTable.push({
              measureName: measureName,
              codeLabel: codeLabel,
              max: element.data[element.data.length - 1].value.toFixed(2),
              maxTime: element.data[element.data.length - 1].time,
              min: element.data[0].value.toFixed(2),
              minTime: element.data[0].time,
            });
          } else {
            maxMinTable.push({
              measureName: measureName,
              codeLabel: codeLabel,
              max: "-",
              maxTime: "-",
              min: "-",
              minTime: "-",
            });
          }
        }
      }
      vm.maxMinTable = maxMinTable;
      let option = vm.charts.getOption();
      option.tooltip = {
        trigger: "axis",
      };
      option.xAxis = {
        type: "category",
        boundaryGap: false,
        axisLine: {
          lineStyle: {
            color: "#bcbdbe",
            width: 2,
          },
        },
        splitLine: { show: false },
        axisLabel: {
          textStyle: {
            color: "#bcbdbe",
          },
        },
        data: xAxisData,
      };
      option.yAxis = {
        name:
          tabType == "forwardFlow" || tabType == "reverseFlow"
            ? forwardFlowUnit
            : tabType !== 'power' ? TAB_UNIT_MAP[tabType] : '',
      };
      option.series = series;
      vm.charts.setOption(option, true);
      vm.addBleBenchmarking();
      vm.loading = false;
    },
    setQoqSeries(apiData, codes, tabType, measureName, dateArr, timeType, isDay) {
      const data = JSON.parse(JSON.stringify(apiData));
      const isTimeInterval = timeType === "timeInterval"
      let vm = this;
      let series = [];
      let maxMinTable = [];
      let legendData = [];
      let timeObj = DateTool.createXAxisObj2(
        timeType,
        dateArr[0].startTime,
        dateArr[0].endTime
      );
      let qoqTimeObj = DateTool.createXAxisObj2(
        timeType,
        dateArr[1].startTime,
        dateArr[1].endTime
      );
      let xAxisObj =
        Object.keys(qoqTimeObj.timeObj) > Object.keys(timeObj.timeObj)
          ? qoqTimeObj.timeObj
          : timeObj.timeObj;
      let xAxisData = [];
      for (let key in xAxisObj) {
        xAxisData.push(key);
      }
      if (vm.showMaxMinTable) {
        vm.columns = [
          { prop: "measureName", label: "测量点名称", show: true },
          { prop: "time", label: "用量时间", show: true },
          {
            prop: "max",
            label: "最大" + codes[0].title,
            align: "right",
            show: true,
          },
          {
            prop: "maxTime",
            label: "最大" + codes[0].title.split("(")[0] + "发生时间",
            show: true,
          },
          {
            prop: "min",
            label: "最小" + codes[0].title,
            align: "right",
            show: true,
          },
          {
            prop: "minTime",
            label: "最小" + codes[0].title.split("(")[0] + "发生时间",
            show: true,
          },
        ];
      }
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        let xObj = JSON.parse(JSON.stringify(xAxisObj));
        let xObjValueData = [];
        let dataArr = [];
        if (isDay) {
          dataArr = element.data[0];
        } else {
          dataArr = element.data;
        }
        for (let j = 0; j < dataArr.length; j++) {
          let time = dataArr[j].time;
          let newTime = null;
          if (typeof time == "string") {
            let timeOne = time;
            time = timeOne;
          }
          xObj[DateTool.format(new Date(time), timeObj.format)] = dataArr[
            j
          ].value.toFixed(2);
        }
        for (let index in xObj) {
          xObjValueData.push(xObj[index]);
        }
        legendData.push(dateArr[i].startTime + "~" + dateArr[i].endTime);
        let format = "";
        if (timeType == "day") {
          format = "yyyy年MM月dd日";
        } else if (timeType == "month") {
          format = "yyyy年MM月";
        } else {
          format = "yyyy年";
        }
        //替代 dateArr[i].startTime  防止被修改
        let alternativeTime = dateArr[i].startTime;
        if (typeof alternativeTime == "string") {
          let newStart = alternativeTime;
          alternativeTime = newStart;
        }
        let name = DateTool.format(new Date(alternativeTime), format);

        if (isTimeInterval && this.$parent.$parent) {
          name = this.$parent.$parent.tabData.find(k => k.value === this.$parent.$parent.selectedTab)?.label
        }
        series.push({
          data: xObjValueData,
          name: name,
          type: "line",
          markPoint: {
            data: [
              { type: "max", name: "最大值" },
              { type: "min", name: "最小值" },
            ],
          },
          lineStyle: {
            width: 3,
          },
          markLine: {
            data: [],
          },
        });

        if (vm.showMaxMinTable == true) {
          if (dataArr.length > 0) {
            dataArr.sort(function(a, b) {
              return a.value - b.value;
            });
            maxMinTable.push({
              measureName: measureName,
              time: name,
              max: dataArr[dataArr.length - 1].value.toFixed(2),
              maxTime: dataArr[dataArr.length - 1].time,
              min: dataArr[0].value.toFixed(2),
              minTime: dataArr[0].time,
            });
          } else {
            maxMinTable.push({
              measureName: measureName,
              time: name,
              max: "-",
              maxTime: "-",
              min: "-",
              minTime: "-",
            });
          }
        }
      }

      if (timeType === 'timeInterval') {
        xAxisData = apiData[0].data.map(k => k.time.slice(0, 13) + '时')
      }

      vm.maxMinTable = maxMinTable;
      let forwardFlowUnit = TAB_UNIT_MAP[tabType];
      if (tabType == "forwardFlow" || tabType == "reverseFlow") {
        forwardFlowUnit =
          vm.forwardFlowUnit.length > 0
            ? vm.forwardFlowUnit
            : TAB_UNIT_MAP[tabType];
      }
      vm.charts.setOption({
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#bcbdbe",
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: "#bcbdbe",
            },
          },
          data: xAxisData,
        },
        yAxis: { name: forwardFlowUnit },
      });
      let option = vm.charts.getOption();
      option.series = series;
      vm.charts.setOption(option, true);
      vm.addBleBenchmarking();
      vm.loading = false;
    },
    async getEventDetectRegulations(id) {
      let vm = this;
      vm.benchmarkingLoading = true;
      await api.measure.getMeasureProperty(id, "").then((res) => {
        if (res) {
          let arr = [];
          let checkIndex = 0;
          let checkList = [];
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].name.indexOf("benchmarking") > -1) {
              let name = res.data[i].name;
              let code =
                name.indexOf("benchmarkingMin") > -1
                  ? name.replace("benchmarkingMin", "")
                  : name.replace("benchmarkingMax", "");
              const index = vm.codes.findIndex((obj) => obj.code == code);
              if (index > -1) {
                // eventDetectRegulations[i].label = item.label;
                // eventDetectRegulations[i].type = item.type;
                // //标识对应编码的图表位置
                // eventDetectRegulations[i].codeIndex = index;
                arr.push({
                  label: res.data[i].displayName,
                  value: res.data[i].value,
                  code: code,
                  codeIndex: index,
                  dataType:
                    name.indexOf("benchmarkingMin") > -1 ? "bottom" : "top",
                });
                checkList.push(checkIndex);
                checkIndex++;
              }
            }
          }
          vm.eventDetectRegulations = arr;
          vm.checkList = checkList;
          vm.benchmarkingLoading = false;
        }
      });
    },
    addBleBenchmarking() {
      let vm = this;
      //1.展示对标线
      let option = vm.charts.getOption();
      let tableData = [];
      //默认清空线
      for (let index = 0; index < option.series.length; index++) {
        option.series[index]["markLine"].data = [];
      }
      let seriesIndex = 0;
      for (let index = 0; index < vm.checkList.length; index++) {
        const element = vm.eventDetectRegulations[vm.checkList[index]];
        if (element) {
          const codeShow = vm.codes.find((c) => c.code == element.code).show;
          if (codeShow) {
            option.series[element.codeIndex]["markLine"].data.push({
              label: element.label,
              yAxis: element.value,
            });
            //获取计算正常非正常值数组
            let seriesData = [];
            if (option.xAxis[0].type === "category") {
              let startTime = new Date(vm.analysisChartObj.startTime);
              for (let i = 0; i < option.xAxis[0].data.length; i++) {
                if (
                  option.xAxis[0].data[i].indexOf("时") > -1 &&
                  option.xAxis[0].data[i].indexOf("日") > -1 &&
                  option.xAxis[0].data[i].indexOf("月") > -1
                ) {
                  startTime.setHours(startTime.getHours() + 1);
                }
                if (option.xAxis[0].data[i].indexOf("时") > -1) {
                  startTime.setHours(startTime.getHours() + 1);
                } else if (option.xAxis[0].data[i].indexOf("日") > -1) {
                  startTime.setDate(startTime.getDate() + 1);
                } else if (option.xAxis[0].data[i].indexOf("月") > -1) {
                  startTime.setMonth(startTime.getMonth() + 1);
                }
                const arr = [
                  dateTool.format(startTime, "yyyy-MM-dd hh:mm:ss"),
                  option.series[element.codeIndex].data[i],
                ];
                seriesData.push(arr);
              }
            } else {
              seriesData = option.series[element.codeIndex].data;
            }
            let obj = calcEventTime(
              seriesData,
              parseFloat(element.value),
              element.dataType
            );
            tableData.push({
              label: element.label,
              normalTime: obj.normal.time,
              normalScale: obj.normal.scale,
              eventTime: obj.event.time,
              eventScale: obj.event.scale,
            });
            seriesIndex++;
          }
        }
        // let series =
      }
      //判断对标的时候   y轴最大最小值问题
      let max = null;
      let min = null;
      for (let i = 0; i < option.series.length; i++) {
        if (!option.series[i].markLine) {
          continue;
        }
        for (let j = 0; j < option.series[i].markLine.data.length; j++) {
          const markLineItem = option.series[i].markLine.data[j];
          if (max && max !== 0) {
            max = markLineItem.data;
          } else {
            max = markLineItem.data > max ? markLineItem.data : max;
          }
          if (min && min !== 0) {
            min = markLineItem.data;
          } else {
            min = markLineItem.data < min ? markLineItem.data : min;
          }
        }
      }
      option.yAxis.max = (extent) => {
        if (max) {
          return extent.max > max ? extent.max : max;
        } else {
          return extent.max;
        }
      };
      option.yAxis.min = (extent) => {
        if (min) {
          return extent.min < min ? extent.min : min;
        } else {
          return extent.min;
        }
      };

      vm.eventTableData = tableData;
      vm.charts.setOption(option);
      vm.visibleBenchmarking = false;
      vm.loading = false;
    },
    /**
     * 重新加载charts
     */
    setChartResize() {
      let vm = this;
      if (vm.charts) {
        vm.charts.resize();
      }
    },
    /**
     *
     */
    setState(data, codes, tabType, measureName, dateObj, timeType) {
      let vm = this;
      let series = [];
      let maxMinTable = [];
      let timeObj = DateTool.createXAxisObj(
        timeType,
        dateObj.startTime,
        dateObj.endTime
      );
      let stateData = [];
      let stateColums = [{ prop: "time", label: "时间", show: true }];
      for (let key in timeObj.timeObj) {
        stateData.push({
          time: key,
        });
      }
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const codeLabel = codes.find(
          (obj) =>
            obj.code == element.pointCode && element.pointNumber == obj.num
        ).title;
        stateColums.push({ prop: "colums" + i, label: codeLabel, show: true });
        let xObj = JSON.parse(JSON.stringify(timeObj.timeObj));
        for (let j = 0; j < element.data.data.length; j++) {
          xObj[
            DateTool.format(new Date(element.data.data[j].time), timeObj.format)
          ] =
            element.data.data[j].value !== null
              ? element.data.data[j].value.toFixed(2)
              : "-";
        }
        let key = 0;
        for (let index in xObj) {
          let stateLabel = "-";
          if (xObj[index] == "0.00") {
            stateLabel = "关闭";
          } else if (xObj[index] == "1.00") {
            stateLabel = "打开";
          } else {
            stateLabel = "-";
          }
          stateData[key]["colums" + i] = stateLabel;
          key++;
        }
      }
      vm.stateColums = stateColums;
      vm.stateData = stateData.reverse();
      vm.statePage.total = stateData.length;
      vm.statePage.pageIndex = 1;
      vm.handleCurrentChange(1);
      vm.loading = false;
    },
    setStateAll(data, codes, tabType, measureName) {
      let vm = this;
      let chartData = [];
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const codeLabel = codes.find(
          (obj) =>
            obj.code == element.pointCode && element.pointNumber == obj.num
        ).title;
        let seriesItemData = [];
        for (let j = 0; j < element.data.data.length; j++) {
          if (element.data.data[j].value == null) {
            seriesItemData.push([element.data.data[j].time, "-"]);
          } else {
            seriesItemData.push([
              element.data.data[j].time,
              element.data.data[j].value.toFixed(2),
            ]);
          }
        }
        chartData.push({
          title: codeLabel,
          data: seriesItemData,
        });
      }
      let stateData = [];
      let stateColums = [{ prop: "time", label: "时间", show: true }];

      for (let index = 0; index < chartData.length; index++) {
        const element = chartData[index];
        stateColums.push({
          prop: "colums" + index,
          label: element.title,
          show: true,
        });
        for (let j = 0; j < element.data.length; j++) {
          // if (index === 0) {
          //   stateData.push({});
          //   stateData[j]["time"] = element.data[j][0];
          // }
          if (!stateData[j]) {
            stateData.push({});
            stateData[j]["time"] = element.data[j][0];
          }
          let stateLabel = "-";
          if (element.data[j][1] == "0.00") {
            stateLabel = "关闭";
          } else if (element.data[j][1] == "1.00") {
            stateLabel = "打开";
          } else {
            stateLabel = "-";
          }
          stateData[j]["colums" + index] = stateLabel;
        }
      }
      vm.stateColums = stateColums;
      vm.stateData = stateData;
      vm.statePage.total = stateData.length;
      vm.statePage.pageIndex = 1;
      vm.handleCurrentChange(1);
      vm.loading = false;
    },

    /**
     * 添加烟感表格分页
     */
    handleSizeChange(val) {
      let vm = this;
      vm.statePage.size = val;
      vm.statePage.pageIndex = 1;
      vm.stateDataToPage = vm.stateData.slice(
        vm.statePage.pageIndex - 1 * vm.statePage.size,
        vm.statePage.size * vm.statePage.pageIndex
      );
    },
    handleCurrentChange(val) {
      let vm = this;
      vm.statePage.pageIndex = val;
      vm.stateDataToPage = vm.stateData.slice(
        (vm.statePage.pageIndex - 1) * vm.statePage.size,
        vm.statePage.size * vm.statePage.pageIndex
      );
    },

    allotMeasuringRealtimeNotifyServer() {
      let vm = this;
      if (document.querySelector("#codeDataList")) {
        vm.$nextTick(() => {
          let height = document.querySelector("#codeDataList").offsetHeight;
          let doms = document.querySelectorAll(".btn-circular");
          for (let i = 0; i < doms.length; i++) {
            let top = 150 + height;
            doms[i].style.top = top + "px";
          }
        });
      }

      if (vm.socket) {
        vm.socket.close();
        vm.socket = null;
      }
      api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        let serverData = res.data;
        vm.socket = new socket({
          //网址（端口是我下面的服务器的端口）
          url:
            window.baseConfig.wsAgreement +
            "://" +
            +serverData.ip +
            ":" +
            serverData.port,
        });

        vm.socket.onopen((event) => {
          vm.socket.send({
            methodCode: "101",
            key: serverData.key,
          });
        });
        //接收信息
        vm.socket.onmessage((data) => {
          vm.webSockMsg(JSON.parse(data));
        });
      });
    },
    webSockMsg(obj) {
      let vm = this;
      if (obj.methodCode == "102") {
        let wsPoints = [
          {
            id: vm.analysisChartObj.measureId,
            points: [],
          },
        ];
        for (let i = 0; i < vm.codes.length; i++) {
          wsPoints[0].points.push({
            code: vm.codes[i].code,
            number: vm.codes[i].num,
          });
        }
        vm.socket.send({
          methodCode: "103",
          measures: wsPoints,
        });
      } else if (obj.methodCode == "105") {
        let codes = JSON.parse(JSON.stringify(vm.codes));
        if (obj.data.length == 0) {
          return;
        }
        for (let j = 0; j < obj.data[0].data.length; j++) {
          let codeIndex = codes.findIndex(
            (c) =>
              c.code == obj.data[0].data[j].pointCode &&
              c.num == obj.data[0].data[j].pointNumber
          );
          if (codeIndex > -1) {
            codes[codeIndex].value = parseFloat(obj.data[0].data[j].value);
          }
        }
        vm.codes = codes;
      } else {
      }
    },
    downTable() {
      exportExcel('downTableId', this.tablesData[this.tabSelectedIndex].label)
    }
  },
};
</script>

<style lang="scss" scoped>
.analysis-chart-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
.tab-small {
  width: 100%;
  height: 30px;
  text-align: left;
  display: flex;
  align-items: center;
}
.tab-small .el-radio-group {
  flex: 1;
}
.tab-small .el-icon-circle-close {
  padding: 0px 10px;
  font-size: 20px;
  cursor: pointer;
}
.table-div {
  width: 100%;
  height: calc(100% - 30px);
}
.table-box {
  margin-top: 14px;
  height: 180px;
}
.checkbox {
  width: 33.3%;
  padding-bottom: 6px;
}
</style>

<style lang="scss" scoped>
.data-list {
  background: #fff;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 0px 10px 10px 10px;
}
.data-item {
  display: flex;
  flex-flow: column;
  width: calc(25% - 12px);
  margin-right: 12px;
  float: left;

  background: #0097ee;
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 10px;

  .value {
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #ffffff;
  }
  .title {
    text-align: center;
    color: #d8d8d8;
  }
}
.data-item:nth-child(4n) {
  margin-right: 0px;
}
.title-box {
  margin-top: 14px;
  padding: 10px;
}
</style>
